import {Navigate} from 'react-router-dom';
import '../style/trackPlayback.less';
import React, {Suspense, lazy} from "react";
import Login from '../container/Login';
import NotFind from '../container/notFind';
import Layout from '../layout/Index';
import FrontendAuth from '../components/FrontendAuth/index';
import SvgIcon from "../components/svgIcon";
import {Spin} from "antd";

let RenderRouter = (prop) => {
    let {name, element} = prop;
    document.title = name;
    let Element = element
    return (
        <Suspense fallback={
            <div className="TrackPlayback">
                <Spin tip="加载中..."
                      spinning={true} size={"large"}
                      style={{fontSize: '45px'}}
                      indicator={<SvgIcon iconClass="loading"/>}/>
            </div>
        }>
            <Element/>
        </Suspense>
    )
}
export default [
    {
        path: "/",
        element: <FrontendAuth component={<Layout/>}/>,
        children: [
            {path: "index", element: <RenderRouter name="首页" element={lazy(() => import('../container/Home'))}/>},
            {path: "machine", element: <RenderRouter name="设备详情" element={lazy(() => import('../container/machine'))}/>},
            {path: "AlarmStatistics", element: <RenderRouter name="告警统计" element={lazy(() => import('../container/statistical/alarm'))}/>},
            {path: "wSituation", element: <RenderRouter name="工作统计" element={lazy(() => import('../container/statistical/work'))}/>},
            {path: "worker", element: <RenderRouter name="工单管理" element={lazy(() => import('../container/order/worker'))}/>},
            {path: "workOrder", element: <RenderRouter name="工单统计" element={lazy(() => import('../container/order/workOrder'))}/>},
            {path: "orderInfo/:id", element: <RenderRouter name="工单详情" element={lazy(() => import('../container/order/info'))}/>},
            {path: "logPush", element: <RenderRouter name="系统日志" element={lazy(() => import('../container/log/index'))}/>},
            {path: "logStatistics", element: <RenderRouter name="人员管理" element={lazy(() => import('../container/system/account'))}/>},
            {path: "machineStatistics", element: <RenderRouter name="设备管理" element={lazy(() => import('../container/system/equipment'))}/>},
            {path: "addMachine", element: <RenderRouter name="设备添加" element={lazy(() => import('../container/system/addMachine'))}/>},
        ]
    },
    {
        path: "/login",
        element: <Login/>,
    },
    {
        path: "/screen",
        element: <RenderRouter name="数据投屏" element={lazy(() => import('../container/screen'))}/>,
    },
    {
        path: "/404",
        element: <NotFind/>,
    },
    {
        path: "*",
        element: <Navigate replace to="/404"/>,
    }
]
